import { mapActions, mapGetters, mapState } from 'vuex'
import userAgentMixin from '@/mixins/userAgent';
import { MODALS } from '@/components/app/app-modals/modals-constants';

export default {
  mixins: [
    userAgentMixin,
  ],
  props: {
    avatar: {},
    theme: {
      type: String,
      default: '',
    },
    radius: {
      type: Number,
      default: 58,
    },
    percentage: {
      type: Number,
      default: 5,
    },
    progressStrokeColor: {
      type: String,
      default: '',
    },
    backgroundStrokeColor: {
      type: String,
      default: '#e6e6e6',
    },
    showProgress: {
      type: Boolean,
      default: true,
    },
    showEdit: {
      type: Boolean,
      default: true,
    },
    notificationsCount: {
      type: Number,
      required: false,
      default: -1,
    },
  },
  computed: {
    ...mapGetters('app', ['hasBanner', 'hasMaintenanceMessage', 'isLayoutMobile']),
    ...mapState('app', ['hasServerErrorOccurred']),
    isRouteActive() {
      return this.$route.name === 'portfolio';
    },
    strokeWidth() {
      if (this.isRouteActive && this.theme === 'nav-top') return 7;
      return 5;
    },
    size() {
      if (this.theme === 'profile') return this.isLayoutMobile ? 90 : 140;
      if (this.theme === 'markets') return 45;
      if (this.theme === 'nav-top') return 32;
      if (this.theme === 'nav-bottom' && !this.isRouteActive) return 30;
      if (this.theme === 'nav-bottom' && this.isRouteActive) return 30;
      if (this.theme === 'large') return 100;
      if (this.theme === 'leaderboards') return 32;
      if (this.theme === 'mobile-menu') return 32;
      if (this.theme === 'user-profile') return 100;
      return 84;
    },
    classModifiers() {
      return {
        'account-social-avatar': true,
        [`account-social-avatar--${this.theme}`]: this.theme,
        'account-social-avatar--active': this.isRouteActive,
        'account-social-avatar--server-error': (this.hasServerErrorOccurred || this.hasMaintenanceMessage || this.hasBanner),
      };
    },
    imageClassModifiers() {
      return {
        'account-social-avatar__oval': true,
        [`account-social-avatar__oval--${this.theme}`]: this.theme,
      };
    },
    imageStyleModifiers() {
      return {
        'background-image': `url('${this.avatar}')`,
        width: `${this.size}px`,
        height: `${this.size}px`,
      };
    },
    labelClassModifiers() {
      return {
        'account-social-avatar__label': true,
        [`account-social-avatar__label--${this.theme}`]: this.theme,
      };
    },
    circReference() {
      return 2 * Math.PI * this.radius;
    },
    styleModifiers() {
      return {
        strokeDashoffset: this.circReference * (1 - (this.percentage / 100)),
        strokeDasharray: this.circReference,
        stroke: this.progressStrokeColor,
      };
    },
    isEditEnabled() {
      // return this.showEdit && !(this.isIos && this.isStandalone);
      return this.showEdit;
    },
    showNotificationsCount() {
      return this.avatar && this.notificationsCount > 0;
    },
    hasLabel() {
      return !!this.$slots.label;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onShowEditPopup() {
      if (this.isEditEnabled) this.setCurrentSmallPopup(MODALS.SMALL_EDIT_IMAGE);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-social-avatar/account-social-avatar.js